'use strict';

var React = require('react');
require('prop-types');
var FormControl = require('../../node_modules/@material-ui/core/esm/FormControl/FormControl.js');
var InputLabel = require('../../node_modules/@material-ui/core/esm/InputLabel/InputLabel.js');
var Select = require('../../node_modules/@material-ui/core/esm/Select/Select.js');
var OutlinedInput = require('../../node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    paper: {
      maxHeight: 250
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 110
    }
  };
};

function formatTime(time) {
  var timeArray = time.split(':');

  if (timeArray.length < 2) {
    return '00:00';
  }

  var hours = parseInt(timeArray[0]);
  var minutes = timeArray[1];
  return hours + ':' + minutes;
}

function TimeSelector(_ref) {
  var classes = _ref.classes,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      time = _ref.time,
      label = _ref.label;

  function windowForTime(hour, minutes) {
    var hourToDisplay = hour % 12 == 0 ? 12 : hour % 12;
    var meridian = hour < 12 ? 'am' : 'pm';
    var display = "".concat(hourToDisplay, ":").concat(minutes).concat(meridian);
    var value = "".concat(hour, ":").concat(minutes);
    return React__default["default"].createElement(MenuItem["default"], {
      key: value,
      value: value
    }, display);
  }

  function timeWindows() {
    var windows = [];

    for (var hour = 0; hour <= 23; hour++) {
      windows.push(windowForTime(hour, '00'));
      windows.push(windowForTime(hour, '30'));
    }

    return windows;
  }

  return React__default["default"].createElement(FormControl["default"], {
    className: classes.formControl,
    variant: "outlined"
  }, React__default["default"].createElement(InputLabel["default"], null, label), React__default["default"].createElement(Select["default"], {
    disabled: disabled,
    MenuProps: {
      classes: {
        paper: classes.paper
      }
    },
    value: formatTime(time),
    input: React__default["default"].createElement(OutlinedInput["default"], {
      labelWidth: 50
    }),
    onChange: function onChange(event) {
      _onChange(event.target.value);
    }
  }, timeWindows()));
}

TimeSelector.defaultProps = {
  time: '00:00:00',
  disabled: false
};
var TimeSelector$1 = withStyles(styles)(TimeSelector);

module.exports = TimeSelector$1;
